export default {
    computed : {
        applicationInsightsConnectionString()
        {
            return window.$env.namespaces.global.aiConnString;
        },
        monitoringLoaded()
        {
            return this.appInsights != null;
        }
    },
    methods: {

        logEvent(name, properties) {
            this.appInsights.trackEvent({ name }, properties);
        },

        logMetric(name, average, properties) {
            this.appInsights.trackMetric({ name: name, average: average }, properties);
        },

        logException(exception, severityLevel = 1) {
            this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
        },

        logTrace(message, properties) {
            this.appInsights.trackTrace({ message: message }, properties);
        },
    }
}